import React from "react";
import { useTranslation } from "react-i18next";
import { servicesInfo } from "./data";
import InfoModal from "./InfoModal";
import ServiceMedia from "./ServiceMedia";
import submit from "submit-form";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const servicesController = async ({ res, req, load, locals }) => {
  const { query = {} } = req;
  const { modal = {} } = query;
  locals.modal = {
    information: <InfoModal service={req.query.service} />,
    "activity-feed": <ActivityDrawer />,
  }[modal.type];
  res.body = <View />;
};

const View = () => {
  const { t } = useTranslation("coaching-portal");
  const openServiceModal = (key) => {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "information",
        service: key,
      },
    });
  };
  return (
    <main className="services-wrapper">
      <header>
        <h3>{t("services.header.title")}</h3>
        <p className="p5">{t("services.header.subtitle")}</p>
      </header>
      <section>
        {Object.keys(servicesInfo).map((key) => {
          const data = servicesInfo[key];
          const title = t(`services.data.${data.dataKey}.title`);
          return (
            <article key={key}>
              <ServiceMedia
                src={data.img}
                onClick={() => openServiceModal(key)}
                alt={t("services.serviceImageAlt")}
              />
              <footer>
                <div>
                  <p className="s1">{title}</p>
                  <p>${data.price} USD</p>
                </div>
                <a
                  role="button"
                  data-button-type="outline"
                  href={data.link}
                  target="_blank"
                >
                  <span>{t("services.buyNow")}</span>
                </a>
              </footer>
            </article>
          );
        })}
      </section>
    </main>
  );
};

export default servicesController;
